export enum DealStatus {
    Draft = 'Draft',
    NewIssueDraft = 'NewIssueDraft',
    Ready = 'Ready',
    Deleted = 'Deleted',
}
